export const twitch = {
  name: 'Twitch',
  id: 'twitch',
  url: 'https://www.twitch.tv/',
  color: '#8250ee',
  compatible: true
}
